import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";

const ActivityLog = () => {
  const styles = {
    activityDesc: {
      minHeight: "30px",
    },
  };

  return (
    <div className="card mb-3">
      <div className=" card-body">
        <strong>Activity (อยู่ในระหว่างการพัฒนา))</strong>
        <ul className="timeline mt-2 mb-0">
          <li className="timeline-item">
            <strong className="text-muted">
              สถานประกอบการรับ / ไม่รับเข้าฝึกงาน
            </strong>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}></p>
          </li>
          <li className="timeline-item">
            <strong className="text-muted">
              ส่งหนังสือออก / รอบริษัทตอบรับ
            </strong>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}>
              {" "}
            </p>
          </li>
          <li className="timeline-item">
            <strong className="text-muted">
              ออกหนังสือขอความอนุเคราะห์แล้ว
            </strong>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}>
              ให้นิสิตมารับหนังสือที่ตึก M ชั้นสาม สำนักงานคณบดี
            </p>
          </li>
          <li className="timeline-item">
            <strong className="text-muted">
              เตรียมออกหนังสือขอความอนุเคราะห์
            </strong>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}>
              เจ้าหน้าที่กำลังออกหนังสือ
            </p>
          </li>
          <li className="timeline-item">
            <strong className="text-muted">อนุมัติคำร้อง</strong>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}>
              อนุมัติเมื่อ
            </p>
          </li>
          <li className="timeline-item">
            <div className="text-muted">ยื่นคำขอฝึกงานแล้ว </div>
            {/* <span className="float-end text-muted text-sm">2d ago</span> */}
            <p className="text-muted" style={styles.activityDesc}>
              รออาจารย์ประจำสาขาวิชาตรวจสอบและกดอนุมัติ
            </p>
          </li>
          <li className="timeline-item">
            <div>
              ลงทะเบียนแล้ว <AiOutlineCheckCircle size="1.4rem" color="green" />
            </div>
            <span className="float-end text-muted text-sm">2d ago</span>
            <p style={styles.activityDesc}>เมื่อวันที่ เวลา</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActivityLog;
